<template>
    <div>
        <div v-if="chapters">
            <draggable v-model="chapters" :options="{draggable: '.list-group-item'}"
                    class="list-group mt-4" @end="saveOrder">
                <router-link v-for="chapter in chapters"
                            :to="{name: 'synthesis-chapter-edit', params: { chapterId: chapter.id}}"
                            class="list-group-item list-group-item-action dd-flex align-items-center"
                            :key="chapter.id">
                    {{chapter.name.text || "Kapitel " + (chapter.position + 1) + " (unbenannt!)"}}
                </router-link>
            </draggable>
        </div>
        <loading v-else></loading>
    </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      chapters: this.data.synthesis.chapters
    };
  },
  watch: {
    data(newData) {
      this.chapters = newData.synthesis.chapters;
    }
  },
  methods: {
    saveOrder() {
      const chapterIds = this.chapters.map(chapter => chapter.id);
      store.commit("addSavingProcess");
      axios
        .post("/api/" + store.state.language + "/chapter/set_chapter_order", {
          ids: chapterIds
        })
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern der Sortier-Reihenfolge ist ein Fehler aufgetreten."
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/chapter/List.vue